import React from "react";
import { DataProtectionPolicy } from "./components/DataProtectionPolicy";
import { GeneralUseConditions } from "./components/GeneralUseConditions";
import { useParams } from "react-router-dom";
import { HeaderTyCDupl } from "./components/HeaderTyCDupl";
import { EnumPrivacyTyC } from "../../commons/EnumsGeneral";

export function TyCInternalPage() {
  const { codePage } = useParams();

  //Aqui poner el renderpage con el switch case
  const renderPage = () => {

    switch (codePage) {
      case EnumPrivacyTyC.DataProtectionPolicy:
        return <DataProtectionPolicy />;
      case EnumPrivacyTyC.GeneralUseConditions:
        return <GeneralUseConditions />;
      default:
        <DataProtectionPolicy />
    }
  };

  return (

    <grid>
      <HeaderTyCDupl />
      {renderPage()}
    </grid>
  );
}
